import { trackExtraCreditsRequestClicked, TrackExtraCreditsRequestPayload } from "app/utils/mixpanel_tracking"
import openSupportConversation from "app/utils/support_conversation"

export const EXTRA_CREDITS_REQUEST_TAG = "extra_credits_request"
export const EXTRA_CREDITS_REQUEST_MESSAGE = "Hi! I'm on the Pro+ plan and I need more credits this month."

export default function requestExtraCredits(payload: TrackExtraCreditsRequestPayload) {
  trackExtraCreditsRequestClicked(payload)

  return openSupportConversation({ tag: EXTRA_CREDITS_REQUEST_TAG, message: EXTRA_CREDITS_REQUEST_MESSAGE })
}
